import React, { useState, useRef } from "react";
import { IonApp, IonCard, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/Olympiad/ClassOne";
import Header from "../../pages/Header";
import Footer from "../../pages/Footer";

const IEO: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    document.title = "Mamas Guidance - Olympiad - Class One"

    return (
        <IonContent>
            <Header />
            <IonCard className='privacy-policy-section'>
                <h1 className='text-center font-50'>IEO</h1>
                <p className="mt-5">
                    <strong>IEO (International English Olympiad)</strong> is a language-based competitive exam conducted by the
                    &nbsp;<strong>Science Olympiad Foundation (SOF)</strong> for students from Class 1 to 12.
                    It aims to assess and improve students’ <em>English grammar, vocabulary, comprehension,</em> and
                    <em>communication skills</em> through interactive and age-appropriate questions.
                </p>
                <div className='mt-5'>
                    <div className="classes-grid">
                        <div className="olympiad-card imo">
                            <h3>Class One</h3>
                            <p>It covers grammar, vocabulary, word usage, comprehension, spelling, punctuation, sentence structure, and basic spoken and written English skills.</p>
                            <a href="/olympiad-classone/ieo">Start Now</a>
                        </div>
                        <div className="olympiad-card nso">
                            <h3>Class Two</h3>
                            <p>It covers grammar, vocabulary, sentence formation, comprehension, punctuation, spelling, nouns, pronouns, verbs, adjectives, and basic communication skills.</p>
                            <a href="/olympiad-classtwo/ieo">Start Now</a>
                        </div>
                        <div className="olympiad-card imo">
                            <h3>Class Three</h3>
                            <p>It covers grammar, vocabulary, word usage, comprehension, spelling, punctuation, sentence structure, and basic spoken and written English skills.</p>
                            <a href="/olympiad-classthree/ieo">Start Now</a>
                        </div>
                    </div>
                </div>
            </IonCard>
            <Footer />
        </IonContent>
    );
};
export default IEO;